import React from 'react';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import ProductPrice from './product-price';
import { StoreAppAPI } from '../../core/src/storeapp-api-client';

import '../css/product-card-bundle-box.less';
const storeAppAPI = new StoreAppAPI();

class ProductCardBundleBox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hovering: false
        }
    }

    onEnterPress = (e) => {
        if (e.keyCode === 13) {
            this.onHover();
        }
    }

    onHover = () => {
        const { sku } = this.props;
        const { bundleProduct } = this.state;
        if (!bundleProduct) {
            storeAppAPI.product.get(sku, "name,itemId,prodId,prdClass,sku", true).then((resp) => {
                if (resp.data && resp.status === 200) {
                    this.setState({
                        bundleProduct: resp.data,
                        hovering: !this.state.hovering
                    })
                }
            })
        } else {
            this.setState({
                hovering: !this.state.hovering
            })
        }
    }

    render() {
        const { sku } = this.props;
        const { hovering, bundleProduct } = this.state;
        return (
            <div className="prd-card-bundle-box" onMouseEnter={this.onHover} onMouseLeave={this.onHover} onKeyDown={this.onEnterPress} tabIndex="0">
                <ImageWithPlaceholder src={`https://www.hp.com/us-en/shop/app/assets/images/product/${encodeURIComponent(sku)}/center_facing.png`} />
                { bundleProduct &&
                    <div className={`item-info${hovering ? '' : ' closed'}`}>
                        <span className="name">{bundleProduct.name}</span>
                        <ProductPrice product={bundleProduct} />
                    </div>
                }

            </div>
        )
    }
}

export default ProductCardBundleBox;